module.exports = "/_next/static/images/LaunchIntegration@2x-17fcae86f882aa01d3cc111aacd67d24.png";